<button
    [ngClass]="{'margin-icon-calculator-not-displayed': advancedOptions === 'closed'}"
    [@animationEqualSystems]="isAnimationEqualSystem ? 'open' : 'closed'"
    (click)="invertSystems.emit()"
    mat-icon-button
    aria-label="Invertir métodos"
    class="big-icon-button">
    <mat-icon [ngClass]="{'rotate': clicked}">swap_vert</mat-icon>
</button>
